import MarketingContentPage from "@/components/marketing/MarketingContentPage"

export default function Changelog() {
  return <MarketingContentPage pageKey="changelog" seoKey="changelog" />
}
